import { render, staticRenderFns } from "./IconTriangle.vue?vue&type=template&id=dd8c8ac2&scoped=true&"
import script from "./IconTriangle.vue?vue&type=script&lang=js&"
export * from "./IconTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8c8ac2",
  null
  
)

export default component.exports